import { render } from "./testimonial-four.vue?vue&type=template&id=0b5460f4"
import script from "./testimonial-four.vue?vue&type=script&lang=js"
export * from "./testimonial-four.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__